import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { Notifications } from "../../../../Constants/Constants";
import { NotificationsData } from "../../../../Data/General/Dashboard/Default";
import { Btn, H6, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";
import { Link } from "react-router-dom";

const NotificationsCard = () => {
  return (
    <Col xl="4" md="6" className="box-col-4">
      <Card className="notification-card">
        <DashboardCommonHeader title={Notifications} dropdownClass="dropdown-toggle" />
        <CardBody className="px-0">
          {NotificationsData.map((item, index) => (
            <div className={`d-flex gap-3 ${item.cardClass}`} key={index}>
              <div className="flex-shrink-0">{item.image ? <Image className="img-40 b-r-6" src={dynamicImage(item.image)} alt="Use1" /> : <span className={`bg-${item.color}`}>{item.word}</span>}</div>
              <div className="flex-grow-1">
                <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>
                  <H6>{item.title}</H6>
                </Link>
                <span>{item.time}</span>
                {item.button && (
                  <div className="d-flex gap-2 p-0 mt-2">
                    <Btn color="dark" outline>Decline</Btn>
                    <Btn color="primary">Accept</Btn>
                  </div>
                )}
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default NotificationsCard;
